export const isFilterDisabled = (
  disabled: boolean | undefined,
  disableOnOtherFilters: string[] | undefined,
  selectedFilters?: Record<string, unknown>
): boolean => {
  if (disabled) return true;
  if (!Array.isArray(disableOnOtherFilters)) return false;

  return disableOnOtherFilters.some((key) => {
    let value = selectedFilters?.[key];
    if (value !== null && typeof value === "object") {
      value = "value" in value ? value.value : undefined;
    }
    return value !== null && value !== undefined && value !== "";
  });
};
